import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export const SITE_URL = 'https://grandpad.biz';
export const DEFAULT_OG_IMAGE = '/images/og-image.jpg';
export const SITE_NAME = 'GrandPad Enterprise Edition';

export interface SEOProps
{
	title: string;
	description: string;
	image?: string;
	applySuffix?: boolean;
	type?: 'website' | 'article';
	noIndex?: boolean;
}

export const SEO = ({title, description, image, applySuffix = true, type = 'website', noIndex = false}: SEOProps) =>
{
	const fullTitle = applySuffix ? `${title} | GrandPad Enterprise` : title;
	const imageUrl = `${SITE_URL}${image ?? DEFAULT_OG_IMAGE}`;
	const { pathname } = useLocation();
	const canonical = `${SITE_URL}${pathname}`;

	return (
		<Helmet>
			<title>{fullTitle}</title>
			<meta name="description" content={description}/>
			<link rel="canonical" href={canonical}/>
			{noIndex && <meta name="robots" content="noindex" />}

			<meta property="og:site_name" content={SITE_NAME}/>
			<meta property="og:type" content={type}/>
			<meta property="og:url" content={canonical}/>
			<meta property="og:title" content={fullTitle}/>
			<meta property="og:description" content={description}/>
			<meta property="og:image" content={imageUrl}/>
			<meta property="og:image:width" content="1200"/>
			<meta property="og:image:height" content="630"/>

			<meta name="twitter:card" content="summary_large_image"/>
			<meta name="twitter:title" content={fullTitle}/>
			<meta name="twitter:description" content={description}/>
			<meta name="twitter:image" content={imageUrl}/>
		</Helmet>
	);
};
